<article class="app_cardItem__container">
  <header class="app_cardItem__header">
    <h3>{{ card.provinciaNombreEstudio }}</h3>
    <div *ngIf="card.datosPorEnviar != null" class="app_cardItem__body_vigencia info">
      <span> {{ card.datosPorEnviar.labelExamen }}</span>
    </div>
    <div *ngIf="card.datosPorEnviar != null && card.datosPorEnviar.fueCerrado === true "
      class="app_cardItem__body_vigencia info">
      <span>{{card.datosPorEnviar.labelCerrado}}</span>
    </div>
    <div *ngIf="card.datosPorEnviar != null && card.datosPorEnviar.error" style=" justify-self: end;"
      class="app_cardItem__body_vigencia red">
      <span>Error de envío</span>
    </div>
    <div *ngIf="card.datosPorEnviar != null && card.datosPorEnviar.error" class="app_cardItem__header__tooltip"
      (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">
      <div>
        <span>
          <button class="app_cardItem__header__button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <defs>
                <style>
                  .bad6affb-2ec5-4f6a-988a-adc5cf9ded47 {
                    fill: #2c4352;
                  }

                  .e1d73c7f-8e67-447e-9ab4-94cf8cb3a0f5 {
                    fill: none;
                  }
                </style>
              </defs>
              <g id="bb233d3e-f114-4862-8701-c3e21bb785be" data-name="Kit_1_rounded_proportion">
                <g id="a4c4dc85-4218-4a15-b601-cb265ac96e67" data-name="Grid_warning_error">
                  <rect class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" x="10.99" y="9" width="2" height="6" rx="1" />
                  <circle id="bea05e1f-6a62-47a1-b3b7-240c09ff4c44" data-name="Elipse 3"
                    class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47" cx="11.99" cy="17.06" r="1.1" />
                  <path class="bad6affb-2ec5-4f6a-988a-adc5cf9ded47"
                    d="M21.33,19,13.91,3.22a2.12,2.12,0,0,0-3.84,0L2.65,19a2.12,2.12,0,0,0,1.92,3H19.41A2.12,2.12,0,0,0,21.33,19ZM4.38,20,12,3.84,19.6,20Z" />
                  <path class="e1d73c7f-8e67-447e-9ab4-94cf8cb3a0f5" d="M0,0H24V24H0Z" />
                </g>
              </g>
            </svg>
          </button>
        </span>
        <span *ngIf="tooltipIsVisible"
          class="app_cardItem__header__tooltip__tooltiptext"><a>{{card.datosPorEnviar.errorMessage}}</a></span>
      </div>
    </div>
  </header>
  <section [ngClass]="
      card.datosPorEnviar != null ? 'app_cardItem__body--fourColumn' : ''    " class="app_cardItem__body">
    <div>
      <div class="app_cardItem__body_title">Trabajador</div>
      <div>
        <span class="elipsis">{{ card.datosPorEnviar?.examenDataToSend?.trabajador?.apellidoNombre ? card.datosPorEnviar?.examenDataToSend?.trabajador?.apellidoNombre : card.trabajador.apellidoNombre }}</span>
      </div>
      <div>
        <span class="app_cardItem__body_title">DNI: </span>
        <span>{{ card.trabajador.numeroDocumento }}</span>
      </div>
    </div>
    <div>
      <div class="app_cardItem__body_title">Esops de exposición</div>
      <div *ngIf="card.esops.length > 0">
        <div>
          <span class="elipsis">
            {{ card.esops[0].codigo }} - {{ card.esops[0].descripcion }}
          </span>
        </div>
        <div class="app_cardItem__body_tinyText">
          1 de {{ card.esops.length }} esops
        </div>
      </div>
      <div *ngIf="card.esops.length == 0">
        <span class="elipsis">
          No Posee
        </span>
      </div>
    </div>

    <div>
      <div class="app_cardItem__body_title">Vigencias en días hábiles</div>
       <div [ngClass]="card.vigenciaColor" class="app_cardItem__body_vigencia">
        <div *ngIf="card.lote.reevaluacion != null">
          <span>{{card.labelVigencia}}</span>
        </div>
      </div>
    </div>

    <div>
      <div class="app_cardItem__body_title">Empresa</div>
      <div>{{ card.lote.empresa.razonSocial }}</div>
      <div class="app_cardItem__body_title">N° de Carpeta</div>
      <div>{{ card.numeroCarpeta }}</div>
    </div>
    <div>
      <div class="app_cardItem__body_title">N° de contrato</div>
      <div>{{ card.lote.numeroContrato }}</div>
      <div class="app_cardItem__body_title">N° de lote</div>
      <div>{{ card.lote.numeroLote }}</div>
    </div>
  </section>
  <footer *ngIf="card.datosPorEnviar == null"
    [ngClass]="card.categoriaExamen == 'reevaluacion' && card.comentarioGestor? 'app_cardItem__footer--reassessmentFooter': ''"
    class="app_cardItem__footer">
    <div *ngIf="card.categoriaExamen == 'reevaluacion' && card.comentarioGestor"
      class="app_cardItem__footer__reassessmentComment">
      <span (click)="openModalComment()">
        <svg id="Capa_1" style="enable-background:new 0 0 24 24;" version="1.1" viewBox="0 0 24 24" x="0px"
          xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" y="0px">
          <style type="text/css">
            .st0 {
              fill: #1E3645;
            }

            .st1 {
              fill: none;
            }
          </style>
          <g>
            <path class="st0" d="M19.03,21c-0.37,0-0.73-0.14-1.01-0.41l-3.09-3.12c-0.02-0.02-0.04-0.03-0.06-0.03H5.59
            c-1.15,0-2.09-0.94-2.09-2.09V5.09C3.51,3.94,4.44,3,5.59,3h12.8c1.15,0,2.09,0.94,2.09,2.09v14.46c0,0.58-0.35,1.11-0.89,1.34
            C19.41,20.96,19.22,21,19.03,21z M19.43,19.17L19.43,19.17L19.43,19.17z M5.59,5C5.55,5,5.51,5.04,5.51,5.09v10.27
            c0,0.05,0.04,0.09,0.09,0.09h9.27c0.55,0,1.09,0.22,1.48,0.62l0,0l2.14,2.15V5.09C18.49,5.04,18.45,5,18.4,5C18.4,5,5.59,5,5.59,5z
            " />
            <path class="st0"
              d="M15.51,9.09H8.48c-0.55,0-1-0.45-1-1s0.45-1,1-1h7.04c0.55,0,1,0.45,1,1S16.06,9.09,15.51,9.09z" />
            <path class="st0"
              d="M15.51,13.36H8.48c-0.55,0-1-0.45-1-1s0.45-1,1-1h7.04c0.55,0,1,0.45,1,1S16.06,13.36,15.51,13.36z" />
            <rect class="st1" height="24" width="24" />
          </g>
        </svg>
        <a>Comentario</a>
      </span>
    </div>
    <div>
      <i *ngIf="!presente && motivoCierre?.descripcion" pTooltip="{{motivoCierre?.descripcion}}" tooltipPosition="left" class="pi pi-info-circle icon-margin"></i>
    </div>
    <div class="app_cardItem__footer__cerrar" style="min-width: 120px; position: relative;">
      <app-cx-dropdown-container (presentismoCierreEvent)="receivePresentismoCierre($event)" [isLastCardItem]="isLastCardItem"
        presentismo="{{ card.firmaB64 }}" motivoCierre="{{ card.motivoCierre }}" [asistencia]="asistencia" dropDownLabel="Asistencia"></app-cx-dropdown-container>
    </div>
    <div class="app_cardItem__footer__cargar">
      <app-cx-button (click)="loadExam()" 
      [isPrimaryButton]="card.firmaB64 == null && (asistencia == null || asistencia == 'Ausente') ? false :true" 
      messageText="Cargar" 
      [isDisabled]="card.firmaB64 == null && (asistencia == null || asistencia == 'Ausente')  ? true : false" 
      [pTooltip]="card.firmaB64 == null && (asistencia == null || asistencia == 'Ausente')  ? 'Es necesaria la firma del trabajador' : null" 
      tooltipPosition="bottom" 
      disabled="true"
      [ngClass]="{'not-allowed': card.firmaB64 == null && (asistencia == null || asistencia == 'Ausente')}"></app-cx-button>  
    </div>
    <div class="app_cardItem__footer__cargar">
      <app-cx-button-pdf (click)="showModalCargaExamenPDF()"
      [isPrimaryButton]="card.firmaB64 == null && (asistencia == 'Ausente') ? false :true"  
      [isDisabled]="card.firmaB64 == null && (asistencia == 'Ausente')  ? true : false" 
      [pTooltip]="card.firmaB64 == null && (asistencia == 'Ausente')  ? 'Es necesaria la firma del trabajador' : null" 
      tooltipPosition="left" 
      disabled="true"></app-cx-button-pdf>
    </div>
  </footer>
  <footer class="app_cardItem__footer--porEnviar" *ngIf="card.datosPorEnviar != null && card.datosPorEnviar.error">
    <div (click)="deleteExam()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <defs>
          <style>
            .ee241f2b-8860-42b8-8abb-0107cf5d005d {
              fill: none;
            }

            .b95d3524-2685-43a8-bac5-56ee48d5279b {
              fill: #555;
            }
          </style>
        </defs>
        <g id="bed4e532-51c9-47e6-82e4-a7400fcdd30f" data-name="Kit_3">
          <g id="e687df95-e02a-479c-954a-67dbd2184732" data-name="Grid_delete_icon_V3">
            <rect class="ee241f2b-8860-42b8-8abb-0107cf5d005d" width="24" height="24" />
            <g id="ef581423-faf0-4a8d-b9aa-a2de6d25cd61" data-name="Trazado">
              <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                d="M21,5.88H16V4a2,2,0,0,0-2-2H10A2,2,0,0,0,8,4V5.88H3a1,1,0,1,0,0,2h.89L5.3,19.37a3,3,0,0,0,3,2.63h7.43a3,3,0,0,0,3-2.63L20.11,7.88H21a1,1,0,0,0,0-2ZM10,4H14V5.88H10ZM16.7,19.13a1,1,0,0,1-1,.87H8.28a1,1,0,0,1-1-.87L5.9,7.88H18.09Z" />
              <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                d="M10,16a1,1,0,0,1-1-1V11.66a1,1,0,0,1,2,0V15A1,1,0,0,1,10,16Z" />
              <path class="b95d3524-2685-43a8-bac5-56ee48d5279b"
                d="M14.05,16a1,1,0,0,1-1-1V11.66a1,1,0,0,1,2,0V15A1,1,0,0,1,14.05,16Z" />
            </g>
          </g>
        </g>
      </svg>
    </div>
  </footer>
</article>

<app-modal-presentismo 
  [displayModalPresente]="displayModalPresente"
  [displayModalFirma]="displayModalFirma" 
  (closeModalPresente)="closeModalPresente()"
  (closeModalFirma)="closeModalFirma()"
  (asistenciaUpdate)="asistenciaUpdate([$event])" 
  (refreshList)="refreshList.emit()"
  nombreTrabajador = "{{card.trabajador.apellidoNombre}}" 
  nombreEstudio = "{{card.provinciaNombreEstudio}}" 
  numeroEstudio = "{{card.id}}"
  [card] = card>
</app-modal-presentismo>

<app-modal-ausencia
(emitCloseExam)="receiveCloseExam($event)"
[displayModalAusente]="displayModalAusente"
(closeModalAusente)="closeModalAusente()"
(asistenciaUpdate)="asistenciaUpdate([$event])" 
nombreTrabajador = "{{card.trabajador.apellidoNombre}}" 
nombreEstudio = "{{card.provinciaNombreEstudio}}" 
numeroEstudio = "{{card.id}}"
[card] = card>
</app-modal-ausencia>

<app-modal-anular-ausencia
  [displayModalAnularAusencia]="displayModalAnularAusencia"
  (closeModalAnularAusencia)="closeModalAnularAusencia()"
  (asistenciaUpdate)="asistenciaUpdate([$event])" 
  (refreshList)="refreshList.emit()"
  nombreTrabajador = "{{card.trabajador.apellidoNombre}}" 
  nombreEstudio = "{{card.provinciaNombreEstudio}}" 
  numeroEstudio = "{{card.id}}">
</app-modal-anular-ausencia>

<app-modal-carga-examen-pdf
    [display]="displayModalCargaExamenPDF"
    [examen]="card"
    (hide)="closeModalCargaExamenPDF()">
</app-modal-carga-examen-pdf>